import { render, staticRenderFns } from "./casehistorydetails.vue?vue&type=template&id=049e5a8e&scoped=true"
import script from "./casehistorydetails.vue?vue&type=script&lang=js"
export * from "./casehistorydetails.vue?vue&type=script&lang=js"
import style0 from "./casehistorydetails.vue?vue&type=style&index=0&id=049e5a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e5a8e",
  null
  
)

export default component.exports